import thunk from 'redux-thunk'
import { fetchVechilesRequest, fetchVechilesSuccess , fetchVechilesFailed } from './actions'
import axios from 'axios'
import store from '../../store'

export const fetchVehicles = (server,params={},successCallback=()=>{},errorCallback=()=>{}) => {
    return dispatch => {
        dispatch(fetchVechilesRequest())
        axios.get(
            `${server}/warehouse/stock-vehicles/`
        )
        .then(
            result => {
                dispatch(fetchVechilesSuccess(result.data))
                successCallback()
            }
        )
        .catch(
            err => {
                dispatch(fetchVechilesFailed(err))
                errorCallback(err)
            }
        )
    }

}


export default fetchVehicles